import { clone as cloneSkinnedSceneRoot } from "three/examples/jsm/utils/SkeletonUtils.js";

function sceneHasSkinnedMesh(root) {
  let found = false;
  root.traverse((o) => {
    if (o.isSkinnedMesh) found = true;
  });
  return found;
}

/**
 * One independent scene graph per placed object; BufferGeometry and materials stay shared (Three Mesh.copy).
 * Skinned GLTFs need SkeletonUtils so cloned meshes bind to cloned bones instead of the template skeleton.
 */
export function cloneGltfSceneForInstance(root) {
  if (!root) return root;
  return sceneHasSkinnedMesh(root)
    ? cloneSkinnedSceneRoot(root)
    : root.clone();
}
